export default (ownPropHandler, contextHandler) => {
  return ownPropHandler && contextHandler
    ? (...args) => ownPropHandler(contextHandler, ...args)
    : contextHandler || ownPropHandler;
};
